module.exports = __webpack_public_path__ + "img/shop-6.eef5c558.jpg";